const storagePathToResolvedUrl = new Map<string, string>();

export function setResolvedImageUrl(pathOrUrl: string, resolvedUrl: string): void {
  try {
    if (!pathOrUrl || !resolvedUrl) return;
    storagePathToResolvedUrl.set(pathOrUrl, resolvedUrl);
  } catch (_) {
    // ignore
  }
}

export function getResolvedImageUrl(pathOrUrl: string): string | undefined {
  try {
    if (!pathOrUrl) return undefined;
    if (pathOrUrl.startsWith('http')) return pathOrUrl;
    return storagePathToResolvedUrl.get(pathOrUrl);
  } catch (_) {
    return undefined;
  }
}

export function hasResolvedImageUrl(pathOrUrl: string): boolean {
  try {
    if (!pathOrUrl) return false;
    if (pathOrUrl.startsWith('http')) return true;
    return storagePathToResolvedUrl.has(pathOrUrl);
  } catch (_) {
    return false;
  }
}


